module.exports = __webpack_public_path__ + "icon-email-196119da48171217b8498851dea0220a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/icon-email.svg
// module id = 1631
// module chunks = 3 6